// extracted by css-extract-rspack-plugin
export default {"stream":"Z5x17","composer":"xWMq_","comment":"RIATv","target":"M4GdM"};